import { type ReactElement } from 'react'
import { AuthenticatedLayout } from '../../shared/components/layouts/AuthenticatedLayout'
import { Container } from '../../routes/app/data-exports/index/Container'

export const APP_DATA_EXPORTS_PATH = '/app/data-exports'

function DataExportsPage (): ReactElement {
  return <Container />
}

DataExportsPage.getLayout = function getLayout (page: ReactElement) {
  return (
    <AuthenticatedLayout>
      {page}
    </AuthenticatedLayout>
  )
}
export default DataExportsPage
